import React, { Component } from 'react'
import { connect } from "react-redux";
import {push as changeURL} from 'react-router-redux';
import { platformParser, mobileSearchBuiler, jumper  } from './uilts'
import {getUrlQeury} from '~/misc/formatUrlquery';
import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import css from './index.css'
import { getTempStorge, setTempStorge } from '~/misc/metrics/timeLimitMetric';
import { setTokenToUser } from '~/modules/user/actions';
import store from '~/store';
import {getParamByUrlAction} from './apis/params'


class EmailCampaignNew extends Component {
  constructor(props){
    super(props);
    this.state = { 
      display : false,
      downloadLink: "",
      detailLink: ""
    }
  }
  async componentWillMount() {
    const urlQuery = getUrlQeury();
    console.log(this.props)
    //to prevent long params that not fit in url,
    //add a get request to get the props. 
    const query = urlQuery.key0 === 'new_email' ? 
      (await this.props.getParamByUrl({id:urlQuery.id})).data : urlQuery;

    const { navigate } = this.props;
    const {campaignLoadId, campaignEmail, campaignQuery, jumpTarget, message_id ,campaign_content, original_source, loginToken,autoAction} = query;


    store.dispatch(setTokenToUser(loginToken));
    const platform = platformParser();
    const campaignQueryObj = campaignQuery ?  JSON.parse(window.atob(campaignQuery)) : '';
    
    const metricData = getTempStorge();
    if(metricData.message_id !== message_id) {
      setTempStorge({
        campaign_content : campaign_content,
        original_source: original_source,
        message_id  : message_id
      })
    }

    if(platform  === 'Android') {
      this.setState({
        detailLink: campaignLoadId ? `truckloads://shipment?id=${campaignLoadId}` : `truckloads://Loadlist_filter?${mobileSearchBuiler(campaignQueryObj)}`,
        downloadLink: "market://details?id=com.truckerpath.truckloads"
      })
    }else if(platform  === 'Ios'){
      this.setState({
        detailLink: campaignLoadId ? `truckloads://shipment?shipmentId=${campaignLoadId}` : `truckloads://Loadlist_filter?${mobileSearchBuiler(campaignQueryObj)}`,
        downloadLink: "itms-apps://itunes.apple.com/gb/app/id1007287939"
      })
    }

    const handler = jumper();
    switch(jumpTarget){
      case "detail": 
        return handler.gotoDetail({
          campaignLoadId,
          campaignQuery,
          loginToken,
          autoAction,
        })
      case "search":
        return handler.gotoSearch({
          campaignQueryObj,
          loginToken
        })
      case "postTruck": 
        return handler.gotoPostTruck({
          loginToken,
          campaignQuery,
          campaignQueryObj,
        })
      case "membership" :
        return handler.gotoMemberShip({
          loginToken,
          campaignQueryObj,
        })
      case "capacityRatio" : 
        return handler.gotoCapacityRatio({
          loginToken,
          campaignQueryObj,
        })
      case "capacityIndicator" : 
        return handler.gotoCapacityIndicator({
          loginToken,
          campaignQueryObj,
        })
    }
  }


  render() {
    const { downloadLink, detailLink,display } = this.state;
    if(!display) {
      return (<div/>)
    } 
    return ( 
      <div className={css.warp}>
        <Button onClick={()=>window.location.href = detailLink }>Open Loads</Button>
        <Button mods={['action']}  onClick={()=>window.location.href = downloadLink} >Download App</Button>
      </div>
    )
  }
}

export default connect(({}) => ({
}), mapDispatch({
  navigate: (props, url) => changeURL(url),
  getParamByUrl: (_, params) => { 
    console.log(params);
    return getParamByUrlAction(params)},
}))(EmailCampaignNew);


// WEBPACK FOOTER //
// ./src/pages/EmailCampaignNew/index.js